import {
  ConsultType,
  ConversationItemDataFragment,
  ConversationStatus,
  Gender,
  Honorific,
  MessageStatus,
  MindFeedbackType,
  MindSessionSummary,
  TemplateEntryType,
} from '../types/api/graphql';
import {
  AgendaAppointmentModalAction,
  ChatMessageActionStatus,
  ChatMessageActionType,
  ChatMessageAppointmentStatus,
  ChatMessagePostedByType,
  ChatMessageType,
} from './enums';

export const PracticeId = 'practice';
export const AllPracticesId = 'all';

export enum AbortType {
  Cancel = 'cancel',
  Back = 'back',
}

export type TemplateEntryItem = {
  id: string;
  name: string;
  type: TemplateEntryType;
  minuteStartTime: string;
  minuteEndTime: string;
  minuteLength: number;
};

export type ChatMessageUser = {
  id?: string;
  firstName: string;
  lastName: string;
  honorific?: string;
  meetingRoomLink?: string | null;
};

export type ChatMessagePostedBy = {
  type: ChatMessagePostedByType;
  id?: string;
  firstName?: string;
  lastName?: string;
};

export type ChatMessageAppointment = {
  id: string;
  startTime: string;
  endTime: string;
  type: ConsultType;
  healthProfessional: ChatMessageUser | null;
  healthProvider?: ChatMessageLocation | null;
  status: ChatMessageAppointmentStatus;
  message?: string;
};

export type ChatMessageLocation = {
  name: string;
  street: string;
  houseNumber: string;
  addition?: string | null | undefined;
  postalCode: string;
  city: string;
};

export type ChatMessageFile = {
  file: string;
  title?: string | null | undefined;
  thumbnail?: string | null | undefined;
};

export type ChatMessageQuestion = {
  id: string;
  question: string;
  answer: string;
};

export type ChatMessageAction = {
  type: ChatMessageActionType;
  title?: string | null | undefined;
  healthProfessional?: ChatMessageUser | null;
  appointment?: {
    consultTypes?: ConsultType[];
    honorifics: Honorific[];
    healthProfessional?: ChatMessageUser | null | undefined;
  };
  status?: ChatMessageActionStatus;
};

export type ChatMessageItem = {
  id?: string;
  type: ChatMessageType;
  postedBy: ChatMessagePostedBy;
  // confirmation that the patient has made an appointment (has appointment id)
  showAppointmentConfirmation: boolean;
  conversationId: string;
  postedAt: string;
  removable?: boolean;
  message?: string;
  appointment?: ChatMessageAppointment;
  files?: ChatMessageFile[];
  questions?: ChatMessageQuestion[];
  actions?: ChatMessageAction[];
  status?: MessageStatus;
  change?: {
    from: boolean | ConversationStatus;
    to: boolean | ConversationStatus;
  };
  advice?: {
    feedback?: MindFeedbackType;
    readonly?: boolean;
    title?: string;
    sessionSummary?: MindSessionSummary;
    otherPerson?: {
      name?: string | null;
      birthdate?: string | null;
      gender?: Gender | null;
    };
  };
};

export type AgendaAppointmentInput = {
  id?: string | null;
  bulkId?: string | null;
  title?: string | null;
  note?: string | null;
  startTime?: string | null;
  endTime?: string | null;
  healthProfessional?: {
    id: string;
  } | null;
  patient?: {
    id: string;
  } | null;
  conversation?: {
    id: string;
  } | null;
  consultType?: ConsultType;
  honorific?: Honorific | null;
  disableHonorific: boolean;
  recurring?: boolean;
  corrupt?: boolean;
  irregular?: boolean;
};

export type BaseModal = {
  onSaved?: () => void;
  onCancel?: () => void;
  onClose?: () => void;
};

export type AppointmentModalData = {
  action?: AgendaAppointmentModalAction;
  healthProviderId: string | null | undefined;
  agendaAppointmentItem?: AgendaAppointmentInput;
} & BaseModal;

export type CreateChatDefaultModalData = {
  type: ChatMessageActionType;
  healthProviderId: string | null | undefined;
  conversationItem: ConversationItemDataFragment | null | undefined;
} & BaseModal;

export type ChatMessageCreateFileModalData = {
  conversationItem: ConversationItemDataFragment | null | undefined;
} & BaseModal;
